import React from "react";
import { motion } from "framer-motion";
import { FaStethoscope, FaBrain, FaHeartbeat, FaCapsules, FaFileMedical, FaUserNurse, FaDna,} from "react-icons/fa";

const newContentBoxes = [
    {
        title: "Smart Hospitals",
        subtitle: "We build AI and IoT-enabled platforms that streamline hospital workflows, improve patient experience, and support real-time care coordination",
        icon: <FaStethoscope className="text-5xl text-[#2a627a]" />,
        bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
        title: "NeuroTech & NeuroTechnology",
        subtitle: "We leverage AI and brain-computer interfaces to enhance cognitive therapies and neurological care with greater precision and accessibility.",
        icon: <FaBrain className="text-5xl text-[#2a627a]" />,
        bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
        title: "Cardio Innovations & Cardiovascular Care",
        subtitle: "We provide AI and wearable solutions for early detection and personalized cardiovascular care.",
        icon: <FaHeartbeat className="text-5xl text-[#2a627a]" />,
        bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
        title: "Pharma Tech & Next-Gen Pharmaceuticals",
        subtitle: "We enable pharma innovation with AI-driven drug discovery, molecular modeling platforms, and secure trial data management.",
        icon: <FaCapsules className="text-5xl text-[#2a627a]" />,
        bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
        title: "EHR, Blockchain & Data Security",
        subtitle: "We build FHIR and HL7-compliant EHRs with blockchain to ensure secure, interoperable, and tamper-proof patient records.",
        icon: <FaFileMedical className="text-5xl text-[#2a627a]" />,
        bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    // {
    //     title: "NeuroTechnology",
    //     subtitle: "Brain-computer interfaces transforming neurological treatments.",
    //     icon: <FaBrain className="text-5xl text-[#2a627a]" />,
    //     bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    // },
    {
        title: "Precision Medicine",
        subtitle: "We use genomics, clinical data, and machine learning to deliver personalized treatments that improve patient outcomes.",
        icon: <FaDna className="text-5xl text-[#2a627a]" />,
        bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    //   {
    //         title: "Cardiovascular Innovation",
    //         subtitle: "AI-driven heart disease prediction & wearable health monitoring.",
    //         icon: <FaHeartbeat className="text-5xl text-[#2a627a]" />,
    //         bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    //     },
    //     {
    //         title: "Next-Gen Pharmaceuticals",
    //         subtitle: "AI accelerating drug discovery & molecular research.",
    //         icon: <FaCapsules className="text-5xl text-[#2a627a]" />,
    //         bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    //     },
    //     {
    //         title: "EHR & Blockchain Security",
    //         subtitle: "Decentralized, tamper-proof patient records using blockchain.",
    //         icon: <FaFileMedical className="text-5xl text-[#2a627a]" />,
    //         bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    //     },

    {
        title: "Nursing & Robotics",
        subtitle: "We develop AI and robotic tools that assist nurses in delivering efficient, responsive patient care..",
        icon: <FaUserNurse className="text-5xl text-[#2a627a]" />,
        bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
];

const FutureHealthTech = () => {
    return (
        <div className="max-w-full mx-auto p-8 space-y-8">
            <h1 className="text-[24px] md:text-[30px] font-semibold text-center bg-gradient-to-r from-[#2a627a] text-gray-800 rounded-xl mb-6">We are Focussing
            </h1>
            <p className="text-sm text-gray-800 text-center">
                Discover innovations in smart hospitals, AI-driven diagnostics, and blockchain-powered EHR.
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:p-10 p-2 bg-white">
                {newContentBoxes.map((box, index) => (
                    <motion.div
                        key={index}
                        className={`flex justify-center items-center h-auto bg-gradient-to-r ${box.bg} p-6 rounded-xl shadow-xl`}
                        whileHover={{
                            scale: 1.05,
                            rotateY: 10,
                            rotateX: 5,
                            transition: { duration: 0.3 },
                        }}
                        whileTap={{ scale: 0.98 }}
                        style={{ perspective: 1000 }}
                    >
                        <motion.div
                            className="relative bg-white p-6 h-auto rounded-xl shadow-lg text-center"
                            whileHover={{ rotateY: -10, rotateX: -5 }}
                        >
                            <motion.div
                                className="flex justify-center mb-3"
                                whileHover={{
                                    y: -20,
                                    scale: 1.2,
                                    rotateX: 15,
                                    rotateY: 10,
                                    transition: { type: "spring", stiffness: 100 },
                                }}
                                style={{
                                    position: "relative",
                                    zIndex: 10,
                                    filter: "drop-shadow(0px 10px 10px rgba(0,0,0,0.2))",
                                }}
                            >
                                {box.icon}
                            </motion.div>

                            <h2 className="text-lg font-bold text-[#2a627a]">{box.title}</h2>
                            <p className="text-gray-800 text-sm mt-2">{box.subtitle}</p>
                        </motion.div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default FutureHealthTech;
